module.exports = __webpack_public_path__ + "img/placeholder_1_1920.f72abf57.jpg";